<template>
    <component
        :is="tag"
        :class="['o-path-step-description', activeClass]"
        @click="onClick"
    >
        <div class="o-path-step-description-index">
            {{ index + 1 }} <span>/{{amountSteps}}</span>
        </div>
        <span class="o-path-step-description-title">
            <template v-if="isOutdoorStep">
                <svg-icon
                    original
                    name="icons/google_maps"
                    class="path-step-google-icon"
                />
                <span class="o-step-text step-text">
                    {{ TRANSLATIONS.DESTINATION_STEP_MESSAGE }}
                </span>
            </template>
            <OStepText
                v-else
                :step="step"
            />
        </span>
        <span
            class="o-path-step-description-distance"
        >
            <AIconButton
                icon="close-adopt"
                class="back-button"
                @onClick="onCloseClick"
            />
        </span>
    </component>
</template>

<script>
import { mapGetters } from 'vuex';
import { computed } from '@vue/composition-api';

import { routerPushHandler } from "@/utils/helpers/common";

import AIconButton from '../../atoms/a-icon-button';
import OStepText from '../../unique-organisms/o-step-text/o-step-text';

import { WEB_INTEGRATION } from "../../../utils/constants/route-constants";
import {OBJECT_INFO_CLOSE_CLICK} from "@/utils/constants/bus-events-constants";
import {REMOVE_PATH} from "@/shared/components/map-viewer/constants/map-commands";

export default {
    name: 'OPathStepDescription',
    components: {
        OStepText,
        AIconButton
    },
    props: {
        index: {
            type: Number,
            default: null
        },
        step: {
            type: Object,
            default: () => ({})
        },
        steps: {
            type: Array,
            default: () => []
        },
        tag: {
            type: String,
            default: 'div'
        },
        isActive: {
            type: Boolean,
            default: false
        },
        isOutdoorItem: {
            type: Boolean,
            default: false
        },
        activePathLength: {
            type: Number,
            default: 0
        },
        destinationObject: {
            type: Object,
            default: () => ({})
        }
    },
    setup(props, { emit }) {
        const activeClass = computed(() => props.isActive ? 'o-path-step-description-active' : null);
        const isOutdoorStep = computed(() => (props.index === props.activePathLength - 1) && props.isOutdoorItem);

        function onClick() {
            emit('onClick', props.index)
        }

        return {
            activeClass,
            isOutdoorStep,
            onClick
        }
    },
    computed: {
        ...mapGetters([
            't'
        ]),
        amountSteps() {
            return this.steps.length;
        },
        isStore() {
            return this.$route.name.includes(WEB_INTEGRATION.STORE.ROOT.NAME)
        },
        destinationStepMessage() {
            return this.t(this.destinationObject, 'destination_step_message');
        },
        TRANSLATIONS() {
            return {
                DESTINATION_STEP_MESSAGE: this.$t(this.destinationStepMessage)
            }
        }
    },
    methods: {
        onCloseClick() {
            this.$bus.$emit(REMOVE_PATH);

            const name = this.isStore ?
                WEB_INTEGRATION.STORE.INFO.NAME :
                WEB_INTEGRATION.CATALOGUE.LIST.NAME;
            this.$bus.$emit(OBJECT_INFO_CLOSE_CLICK);
            this.$router.push({ name, query: {...this.$route.query, mv: 'LevelView'}}, routerPushHandler);
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
